import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import { Route, Routes } from 'react-router-dom';
import ChargeVehicleModelListScreen from '../ChargeVehicleModel/screens/ChargeVehicleModelListScreen';
import ChargeVehicleBrandListScreen from './screens/ChargeVehicleBrandListScreen';

function VehicleBrand(props) {
  return (
    <KT01BaseLayout isFullScreen={true}>
      <div className="container-fluid px-0">
        <Routes>
          <Route path="" element={<ChargeVehicleBrandListScreen />} />
          <Route path=":chargeVehicleBrandId" element={<ChargeVehicleModelListScreen />} />
          <Route path="*" element={<>Đường dẫn không hợp lệ</>} />
        </Routes>
      </div>
    </KT01BaseLayout>
  );
}

export default VehicleBrand;
